(() => {
  console.debug('[GR DEBUG]', 'Catalog list script is ready')
  const API_DOMAIN = window.Shopify.shop
  const API_VERSION = '2024-01'
  const API_TOKEN = 'b5a335382e2c0fc2bb0ffef142877774'

  const init = () => {
    const app = PetiteVue.createApp({
      loading: true,
      b2b: window.hasOwnProperty('gr_sparkLayerFlag'),
      collectionHandle: '',
      collectionTitle: 'Loading...',
      viewMode: 'grid',
      gridView: [],
      listView: [],
      async mounted() {
          const windowUrl = new URL(window.location.href)
          if (windowUrl.searchParams.has('f_vm')) {
            this.viewMode = windowUrl.searchParams.get('f_vm') === 'list' ? 'list' : 'grid'
          }
          console.debug('[GR DEBUG]', 'Catalog list core component mounted')

          const rootElement = document.getElementById('gr-catalog-list-root')
          console.debug('[GR DEBUG]', 'Catalog list, fetch products')
          const inputData = await fetchProducts(rootElement.dataset.collectionHandle)
          console.debug('[GR DEBUG]', 'Catalog list, build render data')
          const renderData = await buildRenderData(inputData)
          console.debug('[GR DEBUG]', 'Catalog list, set new state')

          this.gridView = renderData.gridView
          this.listView = renderData.listView
          this.collectionHandle = rootElement.dataset.collectionHandle
          this.collectionTitle = rootElement.dataset.collectionTitle
          this.loading = false
      },
      async handleViewModeChange() {
        const windowUrl = new URL(window.location.href)
        windowUrl.searchParams.set('f_vm', this.viewMode)
        history.replaceState({}, '', windowUrl.toString())
      },
      async handleAddToCartClick(event, variant) {
        const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        if (window.hasOwnProperty('gr_sparkLayerFlag')) {
          const updateCartData = await spark.updateCart({
            products: [{
                sku: variant.sku,
                adjustQuantity: 1,
            }],
          })

          cartElement && cartElement.classList.remove('is-empty')
          window.gr_updateB2BCartBubble && window.gr_updateB2BCartBubble()
        } else {
          const formData = new FormData()
          formData.append('form_type', 'product')
          formData.append('utf8', '✓')
          formData.append('id', variant.id)
          formData.append('product-id', variant.productId)
          formData.append('sections', 'cart-drawer,cart-icon-bubble')
          formData.append('sections_url', window.Shopify.routes.root + 'collections/' + this.collectionHandle)

          const shopifyCartResponse = await fetch(routes.cart_add_url, {
            mode: 'cors',
            method: 'POST',
            headers: new Headers({
              'Accept': 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            }),
            body: formData,
          })
          const shopifyCartData = await shopifyCartResponse.json()
          cartElement && cartElement.classList.remove('is-empty')
          cartElement && cartElement.renderContents(shopifyCartData)
        }
      },
    }).mount('#gr-catalog-list-root')
    console.debug('[GR DEBUG]', 'Petite vue app mounted', app)
  }

  const fetchProducts = async (collectionHandle = 'all', cursor = false) => {
    try {
      const query = buildProductsQuery(collectionHandle, cursor)
      const response = await fetch(query.url, query.options)
      const data = await response.json()

      if (data.errors || !data.data) {
        onFetchProductsError('Graphql query error in fetch products', data?.errors)

        return []
      }

      if (collectionHandle === 'all' || collectionHandle.length === 0) {
        return data?.data?.collections
      } else {
        return {
          nodes: [data?.data?.collection],
          pageInfo: {
            hasNextPage: false,
            endCursor: '',
          }
        }
      }
    } catch (error) {
      console.error(error)

      return {
        nodes: [],
        pageInfo: {
          hasNextPage: false,
          endCursor: '',
        },
      }
    }
  }

  const buildProductsQuery = (collectionHandle = 'all', cursor = false) => {
    let query = {
      url: `https://${API_DOMAIN}/api/${API_VERSION}/graphql.json`,
      options: {
        mode: 'cors',
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': API_TOKEN,
        }),
      },
    }

    const collectionPartial = `#graphql
      {
        id
        handle
        title

        products(first: 250) {
          nodes {
            id
            handle
            title

            variants(first: 100) {
              nodes {
                id
                title
                sku
                sale: availableForSale

                price {
                  amount
                }

                img: image {
                  url,
                  w: width,
                  h: height
                }
              }
            }

            cd: metafield(namespace: "custom", key: "collection_description") {
              value
            }
          }
        }

        showAll: metafield(namespace: "custom", key: "show_on_all_products") {
          value
        }
      }
    `

    if (collectionHandle === 'all' || collectionHandle.length === 0) {
      // Тягнемо всі колекції одним запитом, без cursor / after
      query.options.body = JSON.stringify({
        query: `#graphql
          query collections @inContext(country: ${window.Shopify?.country || "US"}) {
            collections(first: 250) {
              nodes ${collectionPartial}

              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        `,
      })
    } else {
      query.options.body = JSON.stringify({
        query: `#graphql
          query collection @inContext(country: ${window.Shopify?.country || "US"}) {
            collection(handle: "${collectionHandle}") ${collectionPartial}
          }
        `,
      })
    }

    return query
  }

  const buildSparklayerQuery = (inputProducts = []) => {
    let query = `#graphql
      query FetchPDPData(
        $products: [ProductInput!]!
      ) {
        products(
          products: $products
        ) {
          externalId
          variants {
            sku
            price {
              net
            }
          }
        }
      }
    `

    let variables = {
      products: inputProducts.map(p => {
        return {
          id: p.toString(),
        }
      }),
    }

    return {
      query,
      variables,
    }
  }

  const generateVariantImg = (size, parsedUrl) => {
    parsedUrl.searchParams.set('width', size)

    return parsedUrl.toString()
  }

  const buildRenderData = async (inputData = []) => {
    const isB2B = window.hasOwnProperty('gr_sparkLayerFlag')
    const windowUrl = new URL(window.location.href)
    const pageCollection = windowUrl.pathname.split('/collections/').slice(1).toString()

    let data = {
      gridView: [],
      listView: [],
    }

  let sparkProducts = false, sparkData = false

    if (
      pageCollection === 'all' &&
      inputData &&
      Array.isArray(inputData.nodes) &&
      inputData.nodes.length
    ) {
    const PRIORITY_HANDLE = 'new-arrivals';

      inputData.nodes.sort((a, b) => {
      const aIsPriority = a.handle === PRIORITY_HANDLE;
      const bIsPriority = b.handle === PRIORITY_HANDLE;

      if (aIsPriority && !bIsPriority) return -1;
      if (!aIsPriority && bIsPriority) return 1;
      return 0;
    });
    }

    if (window.hasOwnProperty('gr_sparkLayerFlag')) {
    const inputProducts = Array.from(new Set(inputData.nodes.reduce((acc, collection) => {
      const ids = collection.products.nodes.map(product => {
              return product.id.replace('gid://shopify/Product/', '')
            })

            return [...acc, ...ids]
    }, [])))
      const { query, variables } = buildSparklayerQuery(inputProducts)
      const sparkResponse = await new Promise((resolve, reject) => {
        setTimeout(() => {
        window.spark.fetch(query, variables)
          .then(data => resolve(data))
          .catch(err => reject(err))
        }, 25)
      })
      const sparkJson = await sparkResponse.json()
      sparkProducts = sparkJson.data.products
    }

    await (async () => {
      for (let collection of inputData.nodes) {
        const showOnAllProducts = collection?.showAll !== null && collection?.showAll?.value === 'true'

        if (pageCollection === 'all' && !showOnAllProducts) {
          continue
        }

        let gridSection = {
          id: collection.id,
          title: collection.title,
          subsections: [
            {
              title: 'In stock',
              variants: [],
            },
          ],
        }

        let listSection = {
          id: collection.id,
          title: collection.title,
          subsections: [],
        }

        await (async () => {
          for (let product of collection.products.nodes) {
            let productId = parseInt(product.id.replace('gid://shopify/Product/', ''))
            let listSubsection = {
              id: productId,
              title: product.title,
              variants: [],
            }

            if (sparkProducts) {
            sparkData = sparkProducts.find(p => p.externalId == productId.toString()) || false
            }

            await (async () => {
              for (let variant of product.variants.nodes) {
                const isVariantSample = /^3 .*cigars/gi.test(variant.title)

                if (pageCollection === 'samples' && !isVariantSample) {
                  continue
                }

                if (!variant.sale) {
                  continue
                }

                let variantId = parseInt(variant.id.replace('gid://shopify/ProductVariant/', ''))
                let variantTitle = variant.title
                if (variantTitle === 'Default Title') {
                  variantTitle = product?.cd?.value || 'Product'
                }
                let sparkVariant = sparkData?.variants?.find(v => v.sku === (variant.sku || '')) ?? null
                let b2bPrice = sparkVariant?.price?.net ?? -1
                if (isB2B && b2bPrice === -1) {
                  continue
                }
                let productUrl = window.Shopify.routes.root + 'products/' + product.handle
                let parsedImgUrl = new URL(variant.img.url)
                let subsectionVariant = {
                  id: variantId,
                  title: variantTitle,
                  url: productUrl + '?variant=' + variantId,
                  productId: productId,
                  productTitle: product.title,
                  productHandle: product.handle,
                  productUrl: productUrl,
                  inStock: true,
                  sku: variant.sku,
                  image: variant.img,
                  images: [
                    { w: '165w', url: generateVariantImg(165, parsedImgUrl) },
                    { w: '360w', url: generateVariantImg(360, parsedImgUrl) },
                    { w: '533w', url: generateVariantImg(533, parsedImgUrl) },
                    { w: '720w', url: generateVariantImg(720, parsedImgUrl) },
                    { w: '940w', url: generateVariantImg(940, parsedImgUrl) },
                    { w: '1066w', url: generateVariantImg(1066, parsedImgUrl) },
                  ],
                  showVariantTitle: product.variants.nodes.length > 1,
                  shopifyPrice: parseFloat(variant.price.amount).toFixed(2),
                  b2bPrice: b2bPrice === -1 ? parseFloat(variant.price.amount).toFixed(2) : parseFloat(b2bPrice).toFixed(2),
                }

                gridSection.subsections[0].variants.push(structuredClone(subsectionVariant))
                listSubsection.variants.push(structuredClone(subsectionVariant))
              }
            })()

            if (listSubsection.variants.length > 0) {
              listSection.subsections.push(listSubsection)
            }
          }
        })()
        if (gridSection.subsections[0].variants.length > 0) {
          data.gridView.push(gridSection)
        }

        if (listSection.subsections.length > 0) {
          data.listView.push(listSection)
        }
      }
    })()

    return data
  }

  if (window.hasOwnProperty('gr_sparkLayerFlag')) {
    gr_waitFor(() => {
        console.debug('[GR DEBUG]', 'Waiting for Sparklayer script on collection page...')
        return window.hasOwnProperty('spark')
    }, 30000)
    .then(() => {
      console.debug('[GR DEBUG]', 'Sparklayer is ready, initializing B2B app')
      init()
    })
  } else {
    console.debug('[GR DEBUG]', 'Customer is B2C, initializing default app')
    init()
  }
})()
